import React from "react";

const cbsLogo = () => {
  return (
    <div className="logo">
      <div className="sj_logo">
        <span>SJ Logo</span>
      </div>
      <div className="cbs_logo">
        <span>CBS logo</span>
      </div>
    </div>
  );
}

export default cbsLogo;
